export class LogImport {
    id: string;
    active:boolean;
    nomFichier:string;
    directory:string;
    dateTelechargement:string;
    dateImportation:string;
    nbLigneTrouve:string;
    nbLigneImporte:string;
    status:string;
    downloadBy:string;
    importBy:string;
    //nbDossiers:number;
    //montantDossiers:number;
  }
  